import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Message, Button, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import { WeekScheduler } from '../../../../../common';

import { updateDeliveryPeriods } from '../../../../../../actions';

import './HoursPane.scss';

class HoursPane extends Component {

    constructor(props) {
        super(props);

        this.addDefaultDeliveryHours = this.addDefaultDeliveryHours.bind(this);
    }

    addDefaultDeliveryHours(event, { value }) {
        const defaultHours = Array.from(Array(7)).map((el, index) => {
            const fromDay = index + 1;
            const untilDay = fromDay === 7 ? 0 : fromDay + 1;
            return {days: {from: fromDay, until: untilDay}, closed: true, allDay: null, openTime: '00:00', closeTime: '00:00'};
        });

        this.props.updateDeliveryPeriods(this.props.restaurant.id, defaultHours);
    }

    render() {
        const { restaurant, updateDeliveryPeriods } = this.props;
        const { deliveryHours } = restaurant;


        if (!deliveryHours || (Array.isArray(deliveryHours) && deliveryHours.length === 0)) {
            return (
                <Container fluid>
                    <Message icon>
                        <Icon name='circle warning' />
                        <Message.Content>{i18next.t('noDeliveryHours')}</Message.Content>
                    </Message>
                    <Button icon labelPosition='left' color='blue' onClick={this.addDefaultDeliveryHours}>
                        <Icon name='add to calendar' />
                        {i18next.t('addDeliveryHours')}
                    </Button>
                </Container>
            );
        }

        return (
            <Container fluid className='pi-hours-pane-container'>
                <WeekScheduler
                    restaurant={restaurant}
                    schedule={deliveryHours}
                    updatePeriods={(periods, successCallback) => {updateDeliveryPeriods(restaurant.id, periods, successCallback);}}
                    />
            </Container>
        );
    }
}

HoursPane.propTypes = {
    restaurant: PropTypes.object,
    updateDeliveryPeriods: PropTypes.func,
    
};

export default connect(null, { updateDeliveryPeriods })(HoursPane);